import { CandidateRegistrationDtoClient } from "@/api/candidate/dto/candidate-registration.dto";
import { PayementStatus } from "@/api/enums/PayementStatus";
import { Button } from "@/components/atoms/Button";
import ConfirmDialog from "@/components/molecules/ConfirmDialog";
import FileLink from "@/components/molecules/FileLink";
import { Card, CardTitle } from "@/components/molecules/RegistrationCard/Card";
import { PayementUtil } from "@/lib/payement-util";
import { RegistrationUtil } from "@/lib/registration-util";
import { formatDate } from "@/lib/utils";
import { useState } from "react";
import PayementBadge from "../PayementBadge";
import PayementAcknowledgeDialog from "./PayementAcknowledgeDialog";
import usePayementTransferStatus from "./usePayementTransferStatus";

interface PayementCardProps {
  registration: CandidateRegistrationDtoClient;
  candidateId: number;
}

const PayementCard = ({ registration, candidateId }: PayementCardProps) => {
  const { payementDate } = registration;
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  const cancelPayementMutation = usePayementTransferStatus({
    candidateId,
    successMessage: "Paiement annulé",
    onSuccess: () => setCancelDialogOpen(false),
  });

  return (
    <>
      <ConfirmDialog
        title="Annuler le paiement"
        open={cancelDialogOpen}
        onOpenChange={setCancelDialogOpen}
        validateButtonVariant="red"
        validatePending={cancelPayementMutation.isPending}
        onResult={(confirmed) => {
          if (confirmed)
            cancelPayementMutation.mutate({
              accepted: false,
              registrationId: registration.id,
            });
          else setCancelDialogOpen(false);
        }}
      />
      <Card>
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row gap-2 items-center">
            <CardTitle>Paiement</CardTitle>
            <PayementBadge registration={registration} />
            {PayementUtil.isPaid(registration.payementStatus) && (
              <span>{payementDate && formatDate(payementDate)}</span>
            )}
          </div>
          <FileLink
            showName={false}
            file={RegistrationUtil.currentDebitNote(registration)}
          />
          {(registration.payementStatus ===
            PayementStatus.DELEGATION_PAID_TRANSFER ||
            registration.payementStatus ===
              PayementStatus.PERSONAL_PAID_TRANSFER) && (
            <Button
              variant="ghostRed"
              onClick={() => setCancelDialogOpen(true)}
            >
              Annuler
            </Button>
          )}{" "}
          {(PayementUtil.isWaitingValidation(registration.payementStatus) ||
            registration.payementStatus === PayementStatus.UNPAID) && (
            <PayementAcknowledgeDialog
              registration={registration}
              candidateId={candidateId}
            />
          )}
        </div>
      </Card>
    </>
  );
};

export default PayementCard;
